import { Injectable } from '@angular/core';
import { CanActivate, Router} from '@angular/router';
import {AuthService} from '../../../user/services/auth/auth.service';

@Injectable()
export class CanActivateHomeService implements CanActivate {
  constructor(private auth: AuthService, public router: Router) { }

  canActivate() {
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/layout/services/guards/can-activate-home.service.ts